module.exports = __webpack_public_path__ + "media/alerta-sonido.dabe8342.mp3";